<div id="_FLEET-ADMIN-CENTER_" class="flex flex-col iBTTiny:mx-auto md:m-0 iBTTiny:w-11/12 md:w-full">
  <div class="w-full flex flex-col">
    <div class="ism-gold text-1.75">Fleet Administration</div>
    <div class="w-full flex justify-between">
      <div id="_ADD-FLEET_" class="flex items-center">
        <div class="text-1.5 text-white">Create New Fleet</div>
        <ism-svg data-tooltip="Create New Fleet" class="p-2 tooltip-tr" [name]="'plus'" (click)="createFleet()"></ism-svg>
      </div>
      <div class="flex items-center justify-end">
        <input type="checkbox" [(ngModel)]="showEmptyFleets" class="form-checkbox" />
        <span class="px-2 text-1.25">Empty Fleets</span>
      </div>
    </div>

    <div id="_FLEETS_" class="w-full text-1.125">
      <div class="sticky z-10 top-[3px] bg-black bg-opacity-60 ism-accordion-border">
        <!-- <div class="p-0 h-[2px] top-[3px] bg-yellow-300"></div> -->
        <div id="_Sticky_Header_" class="pl-2 py-2 sticky top-[3px] z-10 w-full tracking-wider flex items-center justify-between ism-gold text-1.125 bg-black bg-opacity-60">
          <div class="text-1.25 font-bold text-left">Fleet Name</div>
          <div class="text-1.25 font-bold flex justify-end">
            <div class="min-w-20 text-center">System</div>
            <div class="min-w-20 text-center">[ Hex ]</div>
            <div class="min-w-16 text-center">Ships</div>
            <div class="min-w-20 text-center">Orders</div>
            <div class="min-w-36 text-center">Action</div>
          </div>
        </div>
        <!-- <div class="p-0 h-[1px] top-[3px] bg-yellow-300"></div> -->
      </div>

      <cdk-accordion class="w-full relative ism-accordion ism-accordion-border scrollbar-none">
        @for (fleet of filteredFleets(); track $index) {
          @let limited = fleet["limited"];
          @let fleets = fleetsByHex[fleet.locationHex];
          <!-- @if(!fleet.turnDeactivated) { -->
          <cdk-accordion-item class="ism-accordion-item ism-accordion-border" [ngClass]="{ amk: $index % 2 == 0 }" #accordionItem="cdkAccordionItem" role="button" [attr.id]="'header-' + $index" [attr.aria-expanded]="accordionItem.expanded" [attr.aria-controls]="'body-' + $index" [scrollToTop] [offset]="192">
            <div id="_Header-Fleet_" class="w-full flex items-center justify-between" (click)="accordionItem.toggle()">
              <div id="_Header-Chevron-Name_" class="py-2 flex items-center ism-white">
                <chevron-toggle [isOpen]="accordionItem.expanded" [classString]="'w-5 h-5  flex items-center ism-gold'"></chevron-toggle>
                <div data-tooltip="Fleet Name" class="font-bold text-1.25 text-clip ism-white tooltip-tr">{{ fleet.fleetName }}</div>
              </div>
              <div id="_Header-Detail_" class="ism-white flex justify-end text-1.25">
                <div data-tooltip="Star System ID" class="min-w-20 text-center tooltip-tl">{{ starSystemsById[fleet.starSystemId]?.number }}</div>
                <div data-tooltip="System Hex" class="min-w-20 text-center tooltip-tr">[ {{ fleet.locationHex }} ]</div>
                <div data-tooltip="Ship Count" class="min-w-16 text-center ism-white tooltip-tr">{{ fleet.shipIds?.length }}</div>
                <div data-tooltip="Order Count" class="min-w-20 text-center ism-white tooltip-tr">{{ fleetOrdersByFleetId[fleet._id]?.length || 0 }}</div>
                <div class="min-w-36 flex justify-end">
                  @if (!limited) {
                    @if (fleets && fleets.length > 1) {
                      <a data-tooltip="Merge Fleet" type="button" class="pl-1 pt-1 tooltip-tl" (click)="mergeFleets($event, fleet, fleets)">
                        <img src="/assets/_icons/arrows_merge_optimized.svg" />
                        <!-- <ism-svg [name]="'arrows_merge'"></ism-svg> -->
                      </a>
                      <a data-tooltip="Reassign Ships" type="button" class="pl-1 pt-1 tooltip-tl" (click)="assignShips($event, fleets)">
                        <img src="/assets/_icons/arrows_assign_optimized.svg" />
                        <!-- <ism-svg [name]="'arrows_assign'"></ism-svg> -->
                      </a>
                    }
                    @if (fleet?.shipIds?.length > 1 && !limited) {
                      <a data-tooltip="Split Fleet" type="button" class="pl-1 pt-1 tooltip-tl" (click)="splitFleet($event, fleet)">
                        <img src="/assets/_icons/arrows_split_optimized.svg" />
                        <!-- <ism-svg [name]="'arrows_split'"></ism-svg> -->
                      </a>
                    }
                    <a data-tooltip="Edit Fleet" type="button" class="pl-1 pr-1 tooltip-tl" (click)="editFleet($event, fleet)">
                      <ism-svg [name]="'pencilSquare'"></ism-svg>
                    </a>
                  }
                </div>
              </div>
            </div>

            <div id="_Detail-Fleet_" class="top-0 z-10 sticky text-1 border-t-2" role="region" [style.display]="accordionItem.expanded ? '' : 'none'" [attr.id]="'body-' + $index" [attr.aria-labelledby]="'header-' + $index">
              <cdk-accordion class="ml-2 flex flex-col">
                <cdk-accordion-item id="_Ships_" class="p-0.5" #accordionShips="cdkAccordionItem" role="button" [attr.id]="'ships-header-' + $index" [attr.aria-expanded]="accordionShips.expanded" [attr.aria-controls]="'ships-body-' + $index">
                  <div id="_Ship-Chevron_" class="py-1 flex items-center" (click)="accordionShips.toggle()">
                    <chevron-toggle [isOpen]="accordionShips.expanded" [classString]="'w-5 h-5 flex items-center ism-gold'"></chevron-toggle>
                    <div class="w-full flex items-center justify-between accordion-header">Ships ({{ fleet.shipIds?.length }})</div>
                  </div>

                  <div id="_Ship-List_" class="text-1" role="region" [style.display]="accordionShips.expanded ? '' : 'none'" [attr.id]="'ships-body-' + $index" [attr.aria-labelledby]="'ships-header-' + $index">
                    @if (fleet?.shipIds?.length > 0) {
                      <table class="ml-4 w-fit border">
                        <tr>
                          <th class="border border-separate bg-gray-800 bg-opacity-85">Ship Name</th>
                        </tr>
                        @let shipIds = fleet?.shipIds;
                        @for (shipId of shipIds; track shipId) {
                          <tr class="data-odd-light">
                            <td class="text-left">{{ shipById[shipId]?.shipName }}</td>
                          </tr>
                        }
                      </table>
                    }
                  </div>
                </cdk-accordion-item>

                <cdk-accordion-item id="_Orders_" class="p-0.5" #accordionOrders="cdkAccordionItem" role="button" [attr.id]="'orders-header-' + $index" [attr.aria-expanded]="accordionOrders.expanded" [attr.aria-controls]="'orders-body-' + $index">
                  <div id="_Order-Chevron_" class="py-1 flex items-center" (click)="accordionOrders.toggle()">
                    <chevron-toggle [isOpen]="accordionOrders.expanded" [classString]="'w-5 h-5 flex items-center ism-gold'"></chevron-toggle>
                    <div class="w-full flex items-center justify-between accordion-header">Fleet Orders ({{ fleetOrdersByFleetId[fleet._id]?.length || 0 }})</div>
                  </div>

                  <div id="_Order-List_" class="text-1" role="region" [style.display]="accordionOrders.expanded ? '' : 'none'" [attr.id]="'orders-body-' + $index" [attr.aria-labelledby]="'orders-header-' + $index">
                    @for (fleetOrder of fleetOrdersByFleetId[fleet._id] | orderBy: "sequence"; track fleetOrder._id) {
                      <fleet-order [fleetOrder]="fleetOrder"></fleet-order>
                    }
                  </div>
                </cdk-accordion-item>
              </cdk-accordion>
            </div>
          </cdk-accordion-item>
          <!-- } -->
        }
      </cdk-accordion>
    </div>
  </div>
</div>
